import { useState } from 'react'
import '../styles/dynamism.scss'
import '../styles/bottomSection.scss'

//import logo from '../assets/Graphicacy-logo.png'

const BottomSection = () => {
  //const [hovered, setHovered] = useState(false)
  const [tile, setTile] = useState(null)

  // const handleMouseEnter = (hoveredTile) => {
  //   setHovered(hoveredTile)
  // }
  // const handleMouseLeave = () => {
  //   setHovered('')
  // }

  const handleExpand = (clickedTile) => {
    if (tile === clickedTile) setTile('')
    else setTile(clickedTile)
  }

  const tileText = {
    dismantle: (
      <div className="tile-text">
        <p>
          Workers thrive in a fluid and competitive labor market. But we have
          come to accept interference in the basic competitive functions of the
          labor market as a normal part of life, rather than a sometimes
          necessary exception. And workers have paid the price.
        </p>
        <p>
          Barriers such as non-compete agreements or excessive occupational
          licensing requirements prevent workers from taking risks, building
          businesses, switching jobs, or moving to opportunity. They also make
          it harder for startups to form and find the right talent, and they
          slow the rate at which knowledge–the feedstock of advances in modern
          productivity–flows through the economy. With non-competes covering an
          estimated 20 percent of the workforce, and with nearly 30 percent of
          workers required to obtain a license to practice their profession,
          barriers to mobility and opportunity erected by policy choices
          directly affect tens of millions of American workers and impede the
          smooth basic functioning of the labor market for everyone else, too.
        </p>
      </div>
    ),
    embrace: (
      <div className="tile-text">
        <p>
          Better immigration policy is one of the most powerful tools available
          for boosting American dynamism. This country remains uniquely
          positioned as the destination of choice for potential immigrants
          worldwide. However, our current immigration regime is ad hoc and
          poorly designed, and it fails to maximize the benefits of immigration
          to the American economy and its workers. In particular, skilled
          immigrants’ high propensity for entrepreneurship makes them net job
          creators. Their innate complementarity with native-born workers boosts
          productivity and earnings for Americans. With demand for knowledge
          workers nearly unlimited in today’s economy, supply is the binding
          constraint on economic growth. Welcoming more highly skilled
          immigrants would help the country perform at the frontiers of its
          potential.
        </p>

        <p>
          Pro-dynamism skilled immigration reform should start by improving
          existing pathways like the H-1B visa so that they are easier to
          administer, decoupled from a single employer, and more readily
          accessible to new, small, and medium-sized enterprises. But improving
          existing pathways is only the beginning. The United States also needs
          new pathways that are linked to specific goals, namely: increasing
          entrepreneurship, boosting STEM talent in the workforce, and
          bolstering the economic well-being of lagging regions.
        </p>
        <p>
          For example, a <strong>startup visa</strong> for immigrant
          entrepreneurs would create a special fast-track for those with
          promising ideas, proven fundraising ability, and the desire to build
          their businesses in the United States and create jobs for native-born
          Americans. A place-based “<strong>heartland visa</strong>” would also
          harness immigration as a regional economic development tool by
          providing benefits and incentives to skilled immigrants who settle in
          parts of the country contending with economic stagnation and the loss
          of prime age workers.
        </p>
      </div>
    ),
    build: (
      <div className="tile-text">
        <p>
          The built environment must be adaptable for the economy to evolve.
          Local housing supplies must be elastic enough to ensure that hubs of
          innovation can also serve as affordable destinations for workers
          seeking better opportunities. Clean technologies must be both
          manufactured and physically deployed in order to decarbonize the
          economy, just as productivity-enhancing infrastructure investments
          must be realized to deliver social and economic dividends. But on all
          of these fronts, the United States has become mired in a costly
          artificial paralysis that has turned our nation’s built environment
          into a hostage of interests deeply opposed to its continued
          development. Simply put: we’ve forgotten how to build.
        </p>
        <p>
          NIMBYism has become nothing short of a monumental threat to progress
          and prosperity. It drives up housing costs and effectively turns our
          most productive centers of economic opportunity into gated
          communities, forcing low- and middle-income workers to live farther
          and farther from their jobs. More expansively, it caps the economy’s
          potential productivity and reduces both wages and living standards.
          Aggressive local, state, and federal leadership is required to pull
          the country out of the morass of regulatory barriers and stakeholder
          vetoes that make the United States the most expensive developed
          country in the world in which to build.
        </p>
      </div>
    )
  }

  return (
    <div className="dynamism-content">
      {/* interactive layer  */}
      <div className="dynamism-solutions">
        <div
          className="solution-box"
          //onMouseEnter={() => handleMouseEnter('dismantle')}
          //onMouseLeave={handleMouseLeave}
        >
          <div>
            <div className="solution-title">
              Dismantle barriers to competition and mobility in the labor market
              <span className="solution-subtitle">
                &nbsp;so that workers can access the jobs they want, in the
                places they choose, at the wages they deserve.
              </span>
            </div>
          </div>
          <div
            className="solution-expand"
            onClick={() => handleExpand('dismantle')}
          >
            see {tile === 'dismantle' ? 'less' : 'more'}
          </div>
          <div className={`solutions-circle ${tile === 'dismantle'}`} />
        </div>
        <div className={`solutions-text-mobile ${tile === 'dismantle'}`}>
          {tileText[tile]}
        </div>

        <div
          className="solution-box"
          //onMouseEnter={() => handleMouseEnter('embrace')}
          // onMouseLeave={handleMouseLeave}
        >
          <div>
            <div className="solution-title">
              Embrace our national advantage as a magnet for skilled immigration
              <span className="solution-subtitle">
                &nbsp;to fuel entrepreneurship and innovation, boost demand for
                American workers, and support the revival of struggling regions.
              </span>
            </div>
          </div>
          <div
            className="solution-expand"
            onClick={() => handleExpand('embrace')}
          >
            see {tile === 'embrace' ? 'less' : 'more'}
          </div>
          <div className={`solutions-circle ${tile === 'embrace'}`} />
        </div>
        <div className={`solutions-text-mobile ${tile === 'embrace'}`}>
          {tileText[tile]}
        </div>
        <div
          className="solution-box"
          //onMouseEnter={() => handleMouseEnter('build')}
          // onMouseLeave={handleMouseLeave}
        >
          <div>
            <div className="solution-title">
              End the tyranny of NIMBYism
              <span className="solution-subtitle">
                &nbsp;to make it easier, faster, and more cost-efficient to
                build housing and infrastructure so that America’s built
                environment can accelerate economic adaptation and resiliency.
              </span>
            </div>
          </div>
          <div
            className="solution-expand"
            onClick={() => handleExpand('build')}
          >
            see {tile === 'build' ? 'less' : 'more'}
          </div>
          <div className={`solutions-circle ${tile === 'build'}`} />
        </div>
        <div className={`solutions-text-mobile ${tile === 'build'}`}>
          {tileText[tile]}
        </div>
      </div>
      <div className={`solutions-text ${tile === 'dismantle'}`}>
        {tileText[tile]}
      </div>
      <div className={`solutions-text ${tile === 'embrace'}`}>
        {tileText[tile]}
      </div>
      <div className={`solutions-text ${tile === 'build'}`}>
        {tileText[tile]}
      </div>
    </div>

    // {/* <div id="dynamism-credit-line">
    //   <div className="dynamism-credit">Designed and built by</div>
    //   <img src={logo} alt="graphicacy" />
    // </div> */}
  )
}
export default BottomSection
